import { LogicalDeleteDTO } from '../basic/logicalDeleteDTO';
import { TenantDTO } from '../domain/tenant';
import { SedeDTO } from '../sede/sede';

export class LocationDTO extends LogicalDeleteDTO {
    
    id: number;
    tenant: TenantDTO;
    descrizione: string;
    emailList: String;
    sede?: SedeDTO;
    greenPassCheckNeeded: boolean;
}